import { addXHeaders, checkUserStatus, getPetDetailApi, getServiceAena } from '@front/apis'
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  changeAppState,
  loadSelectedPet,
  loadSelectedPetGuid,
  loadTokenInformation,
  loadUserToken,
  setPetLoadingStatus,
  setOwnerCardNumber,
  setOwnerEmail,
  setSelectedPet,
  useAppDispatch,
  useAppSelector,
  initLocalization
} from '@front/store'

import i18n from 'i18next'
import { setPet } from './my-store'

const ServicePetition: React.FC = () => {
  // sample url
  // https://webapp.petpass.pro/common/service-petition?ownerCardNumber=123&ownerEmail=andres.montoya@quasarcodes.com&petGUID=09682241-a78e-4f38-17e4d-691ba3ba0018&serviceName=sos
  /*
    VALORES QUE TENGO YA EN EL URL
    serviceName
    petGUID

    VALORES QUE NECESITO
    token
    appGUID
    appUserGUID

    */
  const urlParams = new URLSearchParams(window.location.search)
  const cardOwnerNumber = urlParams.get('ownerCardNumber')
  const ownerEmail = urlParams.get('ownerEmail')
  const petGUID = urlParams.get('petGUID')
  const service = urlParams.get('serviceName')
  const serviceName = service?.split('/')[0] ?? 'home'
  const lang = urlParams.get('idioma') ?? 'es-ES'

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const appState = useAppSelector((state) => state.appState.appNavigationState)

  const validateAndSetUser = async () => {
    const resUserStatus = await checkUserStatus({
      lat: 0,
      lon: 0,
    })

    // console.log('setting OWNER CARD NAME', { cardOwnerNumber })
    dispatch(setOwnerCardNumber(cardOwnerNumber || ''))
    dispatch(setOwnerEmail(ownerEmail || ''))
    if (petGUID) {
      // console.log('setting PET GUID', { petGUID })
      dispatch(loadSelectedPetGuid(petGUID))
      dispatch(setPetLoadingStatus(true))
      dispatch(setSelectedPet(petGUID))
      setPet(petGUID)
    }


    dispatch(
      changeAppState({
        appNavigationState: 'LOGGED_IN_SERVICES',
        isSignUp: true,
        avatar: resUserStatus.data.avatar,
        counters: resUserStatus.data.counters,
        guid: resUserStatus.data.guid,
        petpassRole: resUserStatus.data.petPassRole,
        role: resUserStatus.data.role,
        status: resUserStatus.data.status,
        userName: resUserStatus.data.userName,
        favVetGUID: resUserStatus.data.petpassUserFavVetGUID,
        email: resUserStatus.data.email,
        name: resUserStatus.data.name,
        lastName: resUserStatus.data.lastName,
        phone: resUserStatus.data.phone,
      }),
    )
  }

  useEffect(() => {
    // TODO llamar api para obtene rtoken y lo demas
    const validateToken = async () => {
      // console.log('SERVICE AENA', cardOwnerNumber, ownerEmail, petGUID, service)
      const {
        data: { appGUID, appUserGUID, token },
      } = await getServiceAena({
        ownerCardNumber: cardOwnerNumber || '',
        ownerEmail: ownerEmail || '',
        petGUID: petGUID || '',
        serviceName: serviceName || '',
      })

      if (service === "home" || (!!token && !!service && !!appGUID && !!appUserGUID && appState !== 'LOGGED_IN_SERVICES')) {
        dispatch(
          loadUserToken({
            token,
          }),
        )
        dispatch(
          loadTokenInformation({
            token,
            e360AppGUID: appGUID,
            e360AppUserGUID: appUserGUID,
          }),
        )
        await addXHeaders({
          token,
          e360AppGUID: appGUID,
          e360AppUserGUID: appUserGUID,
        })
        validateAndSetUser()
      }
    }
    validateToken()
  }, [])

  useEffect(() => {
    if (appState === 'LOGGED_IN_SERVICES' && lang) {
      // console.log('lang', lang)
      initLocalization(true).then(() => {
        i18n.changeLanguage(lang)
        validateAndSetUser().then(() => {
          navigate(`/aena/${service}`)
        })
      })
    }
  }, [appState, lang])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
      }}>
      <h1>Redirecting...</h1>
    </div>
  )
}

export default ServicePetition
